import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {InhaberEntitiesActions} from '@adnova/jf-ng-components';
import {distinctUntilChanged, filter, map, pairwise, startWith, tap} from 'rxjs/operators';
import {VersandstatusHistorySelectors} from '../selectors/versandstatus-history.selectors';


/**
 * Leert die {@link VersandstatusHistorySelectors}-Caches, sobald der Nutzer
 * den aktuell ausgewaehlten Betrieb (`currentInhaberId`) wechselt. Verhindert
 * die Akkumulation toter MemoizedSelectors fuer Belege fremder Betriebe ueber
 * die Session-Lebenszeit.
 *
 * Trigger: {@link InhaberEntitiesActions.setCurrentInhaberIdFromURL} — wird
 * vom jf-ng-components-Lifecycle aus dem Router-Param `:inhaber` abgeleitet
 * und ist der team-weit etablierte Schalter fuer "Betrieb gewechselt".
 */
@Injectable()
export class VersandstatusHistoryCacheCleanupEffects {

  readonly clearCacheOnBetriebChange$ = createEffect(() => this.actions$.pipe(
    ofType(InhaberEntitiesActions.setCurrentInhaberIdFromURL),
    map(action => action.currentInhaberId),
    // INFO: `startWith(null)` macht den ersten Wechsel (initial -> erster
    // Inhaber) sichtbar; ohne ihn wuerde `pairwise` erst beim zweiten
    // Inhaber-Wechsel emittieren.
    startWith(null as string | null),
    distinctUntilChanged(),
    pairwise(),
    // INFO: Nur cleanen, wenn vorher bereits ein Betrieb gesetzt war —
    // beim allerersten Setzen (prev === null) gibt es nichts zu invalidieren.
    filter(([prev, curr]) => prev !== null && curr !== prev),
    tap(() => VersandstatusHistorySelectors.clearAll()),
  ), {dispatch: false});

  constructor(private readonly actions$: Actions) {
  }
}
